import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { aws, environment } from './environments/environment';
import { Amplify } from 'aws-amplify';
import './app/shared/extensions/string-extension';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


Amplify.configure(aws);

